var render = function render(){var _vm=this,_c=_vm._self._c;return _c('calculator-velo',{attrs:{"url":_vm.url,"coupon_config":_vm.coupon_config,"calculator_color":_vm.calculator_color,"employer_grant":_vm.employer_grant,"color_button":_vm.color_button,"config_token":_vm.config_token,"portal":_vm.portal,"residual":_vm.residual,"auth_token":_vm.auth_token}})
}
var staticRenderFns = []

export { render, staticRenderFns }